export default "__VITE_ASSET__PlHNr18O__"